import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=a0d7cc72&"
import script from "./HelpCenter.vue?vue&type=script&lang=ts&"
export * from "./HelpCenter.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=a0d7cc72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports